import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'lib-plan-name',
  template: `
    @if ({ row: columnData | async, adata: additionData | async }; as $) {
      @if (getDisplayText($)) {
        <a class="cursor-pointer font-semibold text-900"
          (click)="onGoToRoute($.adata?.uri, $.row, coerceBoolean($.adata?.canRedirect))"
          [pTooltip]="getDisplayText($)"
          tooltipStyleClass="text-xs"
          aria-label="plan-name-link">
          {{ truncate(getDisplayText($), 48) }}
        </a>
      }
      @if ($.row?.name_sec_lang) {
        <div class="text-sm text-600">{{ $.row?.name_sec_lang }}</div>
      }
    }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterModule, TooltipModule, AsyncPipe]
})
export class PlanNameComponent {
  private router = inject(Router);

  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);

  getDisplayText(ctx: any): string {
    const key = ctx?.adata?.keyName || 'name_pri_lang';
    return ctx?.row?.[key] || '';
  }

  truncate(v: string, len: number): string {
    if (!v) return '';
    return v.length > len ? v.slice(0, len) + '...' : v;
  }

  coerceBoolean(v: any): boolean {
    if (typeof v === 'boolean') return v;
    if (typeof v === 'string') return v === 'true';
    return true;
  }

  onGoToRoute(uriTemplate: string, row: any, canRedirect = true) {
    if (!canRedirect || !uriTemplate) return;
    const url = this.buildUrlFromTemplate(uriTemplate, row);
    if (url) {
      this.router.navigate([url]);
    }
  }

  private buildUrlFromTemplate(template: string, row: any): string {
    return template.replace(/:([a-zA-Z0-9_]+)/g, (_match, p1) => {
      const candidates = [p1, this.toSnake(p1), this.toCamel(p1), this.aliasFor(p1)];
      for (const c of candidates) {
        const val = row?.[c];
        if (val !== undefined && val !== null) return String(val);
      }
      return '';
    });
  }

  private toSnake(s: string): string { return s.replace(/[A-Z]/g, m => '_' + m.toLowerCase()); }
  private toCamel(s: string): string { return s.replace(/_([a-z])/g, (_m, c) => c.toUpperCase()); }
  private aliasFor(key: string): string {
    switch (key) {
      case 'id': return 'id';
      case 'planId': return 'plan_id';
      case 'ruleId': return 'rule_id';
      default: return key;
    }
  }
}


